import { useEffect, useState } from "react";
import FormCard from "../../../../../Lib/FormCard";
import GuestDetailForm from "./GuestDetails";
import ContactFormDetails from "./ContectDetails";
import IdentifyForm from "./IdentifyForm";
import ReservationDetails from "./ReservationDetails";
import RoomDetails from "./RoomDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_BYID_ROOM_BOOKING_REQUEST,
  PATCH_ROOM_BOOKING_REQUEST,
  POST_ROOM_BOOKING_REQUEST,
  RESET_BOOKING_SUCCESS,
} from "../../../../../Utils/Constant";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ReviewBookingSummary from "./ReviewSummary";
import { hasEditAccess } from "../../../../../Common/CheckAccess";
import React from "react";
import { toast } from "react-toastify";
import CommonLoading from "../../../../../Common/CommonLoading";

const getInitialState = () => ({
  room_id: "",
  room_type: "",
  check_in_date_time: "",
  check_out_date_time: "",
  booking_type: "",
  booking_source: "",
  agent_name: "",
  purpose_of_visit: "",
  remarks: "",
  total_amount: 0,
  reason: "",
  extra_bed: "",
  total_rooms: 1,
  rooms: [
    {
      room_id: "",
      room_type: "",
      price: 0,
    },
  ],
  services: [],
  booking_status: "",
  package_ids: [],
  guests: [
    {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      country_code: "",
      father_name: "",
      gender: "",
      occupation: "",
      date_of_birth: "",
      nationality: "",
      guest_details: {
        country: "",
        state: "",
        city: "",
        zip_code: "",
        address: "",
        comment: "",
        document_type: "",
        guestDocuments: null,
        guestDocumentUrl: "",
      },
    },
  ],
});

const AddRoomBooking = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const baseUrl = getBaseUrl();
  const reservationInfo = location.state;
  const { rooms } = useSelector((state) => state.frontdesk);
  const [isEditingMode, setIsEditingMode] = useState(false);
  const [submitAction, setSubmitAction] = useState("");
  const [isPaid, setIsPaid] = useState(false);
  const [isDiscounts, setIsDiscounts] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [permissions, setPermissions] = useState([]);
  const [packageAdded, setPackageAdded] = useState(false);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);
  useEffect(() => {
    if (reservationInfo) {
      const roomType = rooms?.data?.find((type) =>
        type.room?.some((room) => room.id === reservationInfo.roomId)
      );
      setFormData((prev) => ({
        ...prev,
        room_id: reservationInfo.roomId,
        room_type: roomType?.id || "",
        rooms: [
          {
            room_id: reservationInfo?.roomId,
            room_type: roomType?.id,
            price: roomType?.price,
          },
        ],
        check_in_date_time: `${reservationInfo.checkIn}T12:00`,
        check_out_date_time: `${reservationInfo.checkOut}T11:00`,
      }));
    }
  }, [reservationInfo]);

  const queryParams = new URLSearchParams(location.search);
  const isViewOnly = queryParams.get("isViewOnly") === "true" || false;

  const [formData, setFormData] = useState(getInitialState());
  const [isLoading, setIsLoading] = useState(false);
  const [packageList, setPackageList] = useState([]);
  const [summaryData, setSummaryData] = useState(null);

  // Add timeout mechanism to prevent stuck loading state
  useEffect(() => {
    let timeoutId;
    if (isLoading) {
      timeoutId = setTimeout(() => {
        console.warn('Loading timeout reached, resetting loading state');
        setIsLoading(false);
        toast.error('Request timed out. Please try again.');
      }, 30000); // 30 seconds timeout
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading]);

  const {
    bookingSuccess,
    roomReservationById,
    isLoading: isLoadingBooking,
    bookingFail,
  } = useSelector((state) => state.roomReservationList);
  const [formErrors, setFormErrors] = useState([]);

  useEffect(() => {
    if (id) {
      dispatch({
        type: GET_BYID_ROOM_BOOKING_REQUEST,
        payload: { reservation_id: id },
      });
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (id && roomReservationById) {
      const {
        check_in_date_time,
        check_out_date_time,
        booking_type,
        total_amount,
        room_number_id,
        rooms: roomDetails,
        extra_bed,
        amenities,
        guests = [],
        purpose_of_visit,
        remarks,
        reason,
        booking_status,
        services,
      } = roomReservationById;

      const formatDate = (datetimeStr) => {
        const date = new Date(datetimeStr);
        return isNaN(date.getTime()) ? "" : date.toISOString().split("Z")[0];
      };

      const mappedGuests = guests.map((guest) => {
        // Ensure guest_details is always an object, not an array
        let guestDetails = guest.guest_details;

        // If guest_details is an array, take the first element
        if (Array.isArray(guestDetails)) {
          guestDetails = guestDetails[0] || {};
        }

        // Ensure all required fields exist
        const normalizedGuestDetails = {
          country: guestDetails?.country || "",
          state: guestDetails?.state || "",
          city: guestDetails?.city || "",
          zip_code: guestDetails?.zip_code || "",
          address: guestDetails?.address || "",
          comment: guestDetails?.comment || "",
          document_type: guestDetails?.document_type || "",
          guestDocuments: guestDetails?.guestDocuments || null,
          frontend_url:
            guestDetails?.frontend_url || guestDetails?.guestDocumentUrl || "",
          country_code: guest.country_code || "",
        };

        return {
          id: guestDetails.guest_id,
          ...guest,
          guest_details: normalizedGuestDetails,
        };
      });

      // Find the room type based on the room number (room_number_id)
      const foundRoomType = rooms?.data?.find((type) =>
        type.room?.some((room) => room.id === room_number_id)
      );

      setFormData({
        check_in_date_time: formatDate(check_in_date_time),
        check_out_date_time: formatDate(check_out_date_time),
        booking_type,
        booking_source: mappedGuests?.length
          ? mappedGuests[0].booking_source
          : "",
        agent_name: mappedGuests?.length ? mappedGuests[0].agent_name : "",
        total_amount,
        room_id: room_number_id,
        room_type: foundRoomType?.id || "",
        rooms:
          roomDetails?.map((item) => ({
            room_id: item.room_id,
            room_type: item.room_type,
            price: item.price || 0,
            capacity: item.capacity || 1,
          })) || [],
        package_ids: services,
        extra_bed,
        services: amenities || [],
        guests: mappedGuests,
        purpose_of_visit,
        remarks,
        reason,
        booking_status: booking_status,
        total_rooms: roomDetails?.length || 0,
      });

      // setIsLoading(false);
    }
  }, [id, roomReservationById, rooms]);

  // Validation function
  const validateForm = () => {
    const errors = [];
    // Check-in and check-out
    if (!formData.check_in_date_time) {
      errors.push("Check-in date and time is required.");
    }
    if (!formData.check_out_date_time) {
      errors.push("Check-out date and time is required.");
    }
    if (formData.check_in_date_time && formData.check_out_date_time) {
      const checkIn = new Date(formData.check_in_date_time);
      const checkOut = new Date(formData.check_out_date_time);
      if (checkOut <= checkIn) {
        errors.push("Check-out must be after check-in.");
      }
    }
    // Booking type
    if (!formData.booking_type) {
      errors.push("Booking type is required.");
    }
    // // Booking status
    // if (!formData.booking_status) {
    //   errors.push("Booking status is required.");
    // }
    // Purpose of visit
    // if (!formData.purpose_of_visit) {
    //   errors.push("Purpose of visit is required.");
    // }

    // At least one guest
    if (!formData.guests || !formData.guests.length) {
      errors.push("At least one guest is required.");
    } else {
      formData.guests.forEach((guest, idx) => {
        if (!guest.first_name) {
          errors.push(`Guest #${idx + 1}: First name is required.`);
        }
        if (!guest.last_name) {
          errors.push(`Guest #${idx + 1}: Last name is required.`);
        }
        if (!guest.email) {
          errors.push(`Guest #${idx + 1}: Email is required.`);
        } else if (!/^\S+@\S+\.\S+$/.test(guest.email)) {
          errors.push(`Guest #${idx + 1}: Email is invalid.`);
        }
        if (!guest.phone) {
          errors.push(`Guest #${idx + 1}: Phone is required.`);
        }
      });
    }
    // At least one room
    if (!formData.rooms || !formData.rooms.length) {
      errors.push("At least one room must be selected.");
    } else {
      formData.rooms.forEach((room, idx) => {
        if (!room.room_id) {
          errors.push(`Room #${idx + 1}: Room selection is required.`);
        }
        if (!room.room_type) {
          errors.push(`Room #${idx + 1}: Room type is required.`);
        }
      });
    }
    return errors;
  };

  const processPayment = async () => {
    setIsLoading(true);
    // if (isViewOnly) return;
    let payment_status = 0;
    if (submitAction === "pay_now") {
      payment_status = 1;
    }
    let hotel_id = localStorage.getItem("hotel_id");
    // --- Build FormData for file upload ---
    const formDataToSend = new FormData();
    // Append all non-file fields
    formDataToSend.append("room_id", formData.room_id);
    formDataToSend.append("room_type", formData.room_type);
    formDataToSend.append("check_in_date_time", `${formData.check_in_date_time}`);
    formDataToSend.append("check_out_date_time", `${formData.check_out_date_time}`);
    formDataToSend.append("booking_type", formData.booking_type);
    formDataToSend.append("purpose_of_visit", formData.purpose_of_visit);
    formDataToSend.append("remarks", formData.remarks);
    formDataToSend.append("total_amount", formData.total_amount);
    formDataToSend.append("reason", formData.reason);
    formDataToSend.append("extra_bed", formData.extra_bed);
    formDataToSend.append("total_rooms", formData.total_rooms);
    formDataToSend.append("booking_status", formData.booking_status);
    formDataToSend.append("payment_status", payment_status);
    formDataToSend.append("hotel_id", hotel_id);
    formDataToSend.append("rooms", JSON.stringify(formData.rooms));
    formDataToSend.append("services", JSON.stringify(formData.services));
    formDataToSend.append("package_ids", JSON.stringify(formData.package_ids));
    if (payment_status === 1) {
      formDataToSend.append("payment_method", paymentMethod);
    }
    // Prepare guests array with document_field for mapping
    const guestsWithDocField = formData.guests.map((guest, idx) => {
      // Use email as unique key if available, else fallback to index
      const guestKey = guest.email ? guest.email : `guest_${idx}`;
      guest.booking_source = formData.booking_source;
      guest.agent_name = formData.agent_name;
      guest.country_code = formData.country_code;
      if (guest.guest_details.guestDocuments instanceof File) {
        // Attach the file with a unique field name
        formDataToSend.append(
          `guestDocument_${guestKey}`,
          guest.guest_details.guestDocuments
        );
        // Reference the field name in the guest object
        guest.guest_details.document_field = `guestDocument_${guestKey}`;
      } else {
        guest.guest_details.document_field = null;
      }
      // Remove the File object from the guest object before stringifying
      delete guest.guest_details.guestDocuments;
      return guest;
    });

    // Add the guests array as a JSON string
    formDataToSend.append("guests", JSON.stringify(guestsWithDocField));
    try {
      if (id) {
        const reservation_id = id;
        dispatch({
          type: PATCH_ROOM_BOOKING_REQUEST,
          payload: {
            reservation_id,
            body: formDataToSend,
            navigate,
          },
        });
      } else {
        dispatch({
          type: POST_ROOM_BOOKING_REQUEST,
          payload: { formDataToSend, navigate },
        });
      }
    } catch (error) {
      console.error("Booking failed:", error);
      toast.error("Booking failed. Please try again.");
      setIsLoading(false); // Reset loading state on error
    } finally {
      setShowPaymentModal(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validation
    const errors = validateForm();
    setFormErrors(errors);
    if (errors.length > 0) {
      toast.error(errors[0]);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsLoading(false); // Stop loader on validation error
      return;
    }
    handleReviewBooking();
    if (id || submitAction === "pay_later") {
      processPayment();
    } else {
      setShowPaymentModal(true);
    }
  };

  useEffect(() => {
    if (bookingSuccess) {
      setIsLoading(false);

      if (!id) {
        // Create a completely fresh state
        const freshState = getInitialState();
        // If there was reservation info from navigation, preserve those fields
        if (reservationInfo) {
          const roomType = rooms?.data?.find((type) =>
            type.room?.some((room) => room.id === reservationInfo.roomId)
          );
          freshState.room_id = reservationInfo.roomId;
          freshState.room_type = roomType?.id || "";
          freshState.check_in_date_time = reservationInfo.checkIn;
          freshState.check_out_date_time = reservationInfo.checkOut;
          // freshState.rooms = [
          //   {
          //     room_id: reservationInfo?.roomId,
          //     room_type: roomType?.id,
          //     price: roomType?.price,
          //   },
          // ];
        }
        setFormData(freshState);
      } else {
        // For update, refetch booking by ID
        dispatch({
          type: GET_BYID_ROOM_BOOKING_REQUEST,
          payload: { reservation_id: id },
        });
      }

      // IMPORTANT: Reset bookingSuccess state to prevent repeated executions
      dispatch({ type: RESET_BOOKING_SUCCESS });
    }

    if (bookingFail) {
      setIsLoading(false);
      // Reset bookingFail state as well
      dispatch({ type: RESET_BOOKING_SUCCESS });
    }
  }, [bookingSuccess, bookingFail, dispatch, id, reservationInfo, rooms?.data]);
  
  // Debug logging for loading state
  useEffect(() => {
    console.log('Loading state changed:', isLoading);
    console.log('Booking success:', bookingSuccess);
    console.log('Booking fail:', bookingFail);
  }, [isLoading, bookingSuccess, bookingFail]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Special handling for checkout date time
    if (name === "check_out_date_time" && value) {
      // Only set default time to 11 PM if form doesn't already have checkout time data
      if (
        !formData.check_out_date_time ||
        formData.check_out_date_time === ""
      ) {
        const dateOnly = value.substring(0, 10); // Get just the date part (YYYY-MM-DD)

        // If time is 00:00 (default when user only selects date), set it to 23:00 (11 PM)
        const newValue = `${dateOnly}T11:00`;
        setFormData((prev) => ({
          ...prev,
          [name]: newValue,
        }));
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: name === "total_amount" ? Number.parseInt(value) || 0 : value,
    }));
  };

  useEffect(() => {
    if (!(isEditingMode || isViewOnly) && formData.total_rooms > 0) {
      let arr = [];
      for (let i = 0; i < formData.total_rooms; i++) {
        arr.push({ room_id: "", room_type: "", price: "" });
      }
      setFormData((pre) => ({ ...pre, rooms: arr }));
    }
  }, [formData.total_rooms]);

  const handleRoomChange = (e, i) => {
    const { name, value } = e.target;
    let obj = formData.rooms.map((data, index) => {
      if (index === i) {
        if (name === "room_type" && !!formData.rooms[i].room_id) {
          return { [name]: value, room_id: "", price: 0 };
        }
        if (
          name === "room_id" &&
          formData?.rooms.find((item) => item.room_id == value)
        ) {
          return data;
        }
        if (name === "price") {
          return { ...formData.rooms[i], [name]: value };
        }
        const roomType = rooms?.data?.find((type) =>
          type.room?.some((room) => room.id === value)
        );
        return {
          ...formData.rooms[i],
          [name]: value,
          price: roomType?.price,
          capacity: roomType?.capacity,
        };
      } else return data;
    });
    setFormData((pre) => ({
      ...pre,
      rooms: obj,
    }));
  };

  const updateGuestData = (guestIndex, updatedGuest) => {
    const updatedGuests = [...formData.guests];
    updatedGuests[guestIndex] = updatedGuest;
    setFormData((prev) => ({ ...prev, guests: updatedGuests }));
  };

  const addGuest = () => {
    setFormData((prev) => ({
      ...prev,
      guests: [
        ...prev.guests,
        {
          // Use the initial state structure directly - guest_details as object, not array
          ...getInitialState().guests[0],
          guest_details: { ...getInitialState().guests[0].guest_details }, // Keep as object
        },
      ],
    }));
  };

  const removeGuest = (index) => {
    const updatedGuests = formData.guests.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, guests: updatedGuests }));
  };

  const handleServiceChange = (index, field, value) => {
    const updatedServices = [...formData.services];
    updatedServices[index] = {
      ...updatedServices[index],
      [field]: value,
    };
    setFormData((prev) => ({ ...prev, services: updatedServices }));
  };

  const addService = () => {
    setFormData((prev) => ({
      ...prev,
      services: [...prev.services, { service_id: "", name: "", price: "" }],
    }));
  };

  const removeService = (index) => {
    const updatedServices = formData.services.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, services: updatedServices }));
  };

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        let token = localStorage.getItem("token");
        let hotel_id = localStorage.getItem("hotel_id");

        const res = await fetch(
          `${baseUrl}/room/package/all?hotel_id=${hotel_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const response = await res.json();

        if (response?.data?.data) {
          setPackageList(response.data.data || []);
        } else {
          console.error("Invalid response structure:", response);
        }
      } catch (error) {
        console.error("Failed to fetch packages:", error.message);
        // Optionally: show UI message or set error state
      }
    };

    fetchPackages();
  }, [packageAdded]);

  const handleReviewBooking = async (formdta) => {
    if (
      !formData?.check_in_date_time ||
      !formData?.check_out_date_time ||
      !formData?.rooms?.every((item) => item.room_id && item.room_type)
    ) {
      toast.warning("Please select all required fields.");
      return;
    }
    try {
      // Prepare payload with all form data
      const payload = {
        ...(formdta || formData),
        rooms: formdta?.rooms || formData?.rooms,
        packages: formdta?.package_ids || formData?.package_ids,
        total_rooms: formdta?.total_rooms || formData?.total_rooms,
        services: formdta?.services || formData?.services,
        guests: formdta?.guests || formData?.guests,
      };

      if (isEditingMode || isViewOnly || id) {
        if (!id) return;
        let token = localStorage.getItem("token");
        let hotel_id = localStorage.getItem("hotel_id");

        let response = await fetch(
          `${baseUrl}/billing/folio/reservation/${id}?hotel_id=${hotel_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch summary");
        }

        const result = await response.json();
        // setIsPaid(result?.data?.balance > 0 ? false : true);

        // Constants
        const GST_RATES = result?.data?.GST; // for services
        // const nights = 2 // based on room charge description
        // const extraBedRatePerNight = 0
        const extraBedCount = 0;

        // Initialize accumulators
        let totalRoomCharges = 0;
        let totalServiceCharges = 0;
        let totalTaxAmount = 0;
        let extraBedCharges = 0;
        let totalDiscounts = 0;
        let totalRestaurantCharges = 0;
        let totalAmountPaid = 0;
        // Rooms
        const roomsPrice = result?.data?.charges
          ?.filter((charge) => charge.charge_type === "room_charge")
          .map((charge) => {
            const pricePerNight = parseFloat(charge.unit_price);
            const nights = charge.quantity;
            const baseAmount = pricePerNight * nights;

            totalRoomCharges += baseAmount - parseFloat(charge.discount || 0);
            totalDiscounts += parseFloat(charge.discount || 0);
            if (charge.payment_status) {
              totalAmountPaid += baseAmount - totalDiscounts;
            }
            return {
              room: {
                room_id: charge.room_id,
                room_number: charge.details,
                room_type: charge.item_description,
              },
              price_per_night: pricePerNight,
              total_room_price: baseAmount,
              total_amount: baseAmount,
              total_nights: nights,
              discount: charge.discount,
              payment_status: charge.payment_status,
            };
          });

        // Services
        const servicesData = result?.data?.charges
          .filter((charge) => charge.charge_type === "service_charge")
          .map((charge) => {
            const rate = parseFloat(charge.unit_price);
            const quantity = charge.quantity;
            const baseAmount = rate * quantity;

            totalServiceCharges += baseAmount;
            if (charge.payment_status) {
              totalAmountPaid += baseAmount;
            }
            return {
              service: {
                id: charge.id,
                package_name: charge.item_description,
                description: charge.description,
              },
              price_per_night: rate,
              total_service_price: baseAmount,
              total_amount: baseAmount,
              quantity: quantity,
              discount: 0,
              payment_status: charge.payment_status,
            };
          });
        // Tax
        totalTaxAmount = parseFloat(
          parseFloat(
            ((totalRoomCharges + totalServiceCharges) *
              (GST_RATES.room_reservation_tax || 0)) /
              100
          ).toFixed(2)
        );

        if (totalAmountPaid) {
          totalAmountPaid += totalTaxAmount;
        }
        const restaurantData = result?.data?.charges
          .filter((charge) => charge.charge_type === "restaurant")
          .map((charge) => {
            const rate = parseFloat(charge.unit_price || 0);
            const quantity = charge.quantity || 0;
            const baseAmount = rate * quantity;
            const discount = parseFloat(charge.discount || 0);
            const amount = parseFloat(charge.amount || 0);
            totalRestaurantCharges += amount;

            let tip = 0,
              gstAmount = 0,
              serviceCharge = 0,
              orderId = "-";
            try {
              const details = charge.details ? JSON.parse(charge.details) : {};
              tip = parseFloat(details.tip || 0);
              gstAmount = parseFloat(details.gst_amount || 0);
              serviceCharge = parseFloat(details.service_charge || 0);
              orderId = details.order_id || "-";
            } catch (e) {
              console.warn("Invalid JSON in details:", charge.details);
            }

            if (charge.payment_status) {
              totalAmountPaid += amount;
            }
            // totalRestaurantCharges += amount;
            return {
              restaurant: {
                id: charge.id,
                name: `Order`,
                description: charge.description,
              },
              price_per_night: rate,
              total_restaurant_price: baseAmount,
              total_amount: amount,
              quantity,
              discount,
              tip,
              gstAmount,
              serviceCharge,
              payment_status: charge.payment_status,
            };
          });
        // // Extra bed charges
        // if (extraBedCount > 0) {
        //   extraBedCharges = extraBedRatePerNight * nights * extraBedCount
        // }

        // Subtotal and grand total
        const subtotal =
          totalRoomCharges + totalServiceCharges + totalRestaurantCharges;
        const grandTotal = subtotal + totalTaxAmount;

        // Final result
        const data = {
          roomsPrice,
          servicesData,
          restaurantData: restaurantData,
          extraBed: {
            count: extraBedCount,
            baseAmount: extraBedCharges,
            taxAmount: 0,
            totalAmount: extraBedCharges,
          },
          totalRestaurantCharges,
          totalRoomCharges,
          totalDiscounts,
          totalServiceCharges,
          totalExtraBedCharges: extraBedCharges,
          subtotal,
          totalTaxAmount,
          grandTotal,
          totalAmountPaid: totalAmountPaid,
        };

        setIsDiscounts(totalDiscounts > 0 ? true : false);
        setSummaryData(
          {
            data: data,
            payload: {
              check_in_date_time: result?.data?.reservation?.check_in_date_time,
              check_out_date_time:
                result?.data?.reservation?.check_out_date_time,
            },
          } || []
        );
      } else {
        if (
          !payload.check_in_date_time ||
          !payload.check_out_date_time ||
          !payload.rooms?.length
        ) {
          throw new Error("Check In , Check out Time or rooms are required!");
        }
        let token = localStorage.getItem("token");
        let hotel_id = localStorage.getItem("hotel_id");

        // Call API (replace with your actual API endpoint)
        const response = await fetch(
          `${baseUrl}/reservation/calculate-prices?hotel_id=${hotel_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // ← Add your token here
            },
            body: JSON.stringify({ ...payload, hotel_id }),
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch summary");
        }

        const result = await response.json();
        setSummaryData(result?.data || []);
      }
    } catch (error) {
      console.error("Error fetching summary:", error);
    } finally {
    }
  };
  useEffect(() => {
    if (
      (isViewOnly || id) &&
      formData?.check_in_date_time &&
      formData?.check_out_date_time &&
      formData?.rooms?.every((item) => item.room_id && item.room_type)
    ) {
      handleReviewBooking(formData);
    }
  }, [isViewOnly, id, formData]);

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CommonLoading />
        </div>
      )}
      <div
        className="add-room-booking-container"
        style={{ padding: "5%", paddingTop: "2%" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <h1 style={{ margin: 0 }}>
            {isViewOnly
              ? "Room Booking"
              : id
              ? "Edit Room Booking"
              : "Add Room Booking"}
          </h1>

          <div className="d-flex gap-2 justify-content-between">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </button>
            {isViewOnly &&
              !isEditingMode &&
              hasEditAccess(permissions, "reservation") && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    const currentPath = location.pathname;
                    navigate(currentPath);
                    setIsEditingMode(true);
                  }}
                >
                  Edit
                </button>
              )}

            {isEditingMode && (
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => {
                  const currentPath = location.pathname;
                  navigate(`${currentPath}?isViewOnly=true`);
                  setIsEditingMode(false);
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <ReservationDetails
            formData={formData}
            handleChange={handleChange}
            isViewOnly={isViewOnly}
            handleRoomChange={handleRoomChange}
            isEditingMode={isEditingMode}
            id={id}
          />

          <FormCard>
            <div className="card-body row g-3">
              {formData.guests.map((guest, guestIndex) => (
                <div key={guestIndex} className="col-12">
                  <GuestDetailForm
                    guestIndex={guestIndex}
                    guestData={guest}
                    setGuestData={updateGuestData}
                    isViewOnly={isViewOnly}
                    onRemoveGuest={removeGuest}
                  />

                  <div className="row">
                    <div className="col-md-6">
                      <ContactFormDetails
                        formData={guest.guest_details} // This is now always an object
                        handleChange={(e) => {
                          const updatedGuests = [...formData.guests];
                          updatedGuests[guestIndex].guest_details = {
                            ...updatedGuests[guestIndex].guest_details,
                            [e.target.name]: e.target.value,
                          };
                          setFormData((prev) => ({
                            ...prev,
                            guests: updatedGuests,
                          }));
                        }}
                        isViewOnly={isViewOnly}
                      />
                    </div>

                    <div className="col-md-6">
                      <IdentifyForm
                        formData={guest.guest_details} // This is now always an object
                        guestDocuments={guest.guest_details.guestDocuments} // Fixed reference
                        handleChange={(e) => {
                          const updatedGuests = [...formData.guests];
                          updatedGuests[guestIndex].guest_details = {
                            ...updatedGuests[guestIndex].guest_details,
                            [e.target.name]: e.target.value,
                          };
                          setFormData((prev) => ({
                            ...prev,
                            guests: updatedGuests,
                          }));
                        }}
                        handleFileChange={(file) => {
                          const url = URL.createObjectURL(file);
                          const updatedGuests = [...formData.guests];
                          updatedGuests[guestIndex].guest_details = {
                            ...updatedGuests[guestIndex].guest_details,
                            guestDocuments: file,
                            document_field: guestIndex,
                            guestDocumentUrl: url,
                            frontend_url: url,
                          };
                          setFormData((prev) => ({
                            ...prev,
                            guests: updatedGuests,
                          }));
                        }}
                        isViewOnly={isViewOnly}
                        guestDocumentUrl={
                          guest.guest_details.frontend_url ||
                          guest.guest_details.guestDocumentUrl
                        }
                      />
                    </div>
                  </div>

                  {formData.guests.length > 1 && !isViewOnly && (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm mt-2"
                      onClick={() => removeGuest(guestIndex)}
                    >
                      Remove Guest
                    </button>
                  )}
                </div>
              ))}

              <div className="col-12">
                {!isViewOnly && (
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={addGuest}
                  >
                    + Add Guest
                  </button>
                )}
              </div>
            </div>
          </FormCard>
          <RoomDetails
            formData={formData}
            handleRoomChange={handleRoomChange}
            handleChange={handleChange}
            handleServiceChange={handleServiceChange}
            addService={addService}
            removeService={removeService}
            isEditingMode={isEditingMode}
            isViewOnly={isEditingMode || isViewOnly}
            packageList={packageList}
            onPackageAdded={() => setPackageAdded((pre) => !pre)}
          />
          {!isViewOnly && !isEditingMode && (
            <div className=" row  w-full flex p-2 m-1  ">
              <button
                onClick={() => {
                  handleReviewBooking();
                }}
                type="button"
                className="btn btn-success"
              >
                Review booking
              </button>
            </div>
          )}
          <div className="row">
            {summaryData && (
              <ReviewBookingSummary id={id} summaryData={summaryData} />
            )}
          </div>

          <div className="submit-button-container mt-3 d-flex justify-content-among gap-3 align-items-center">
            <>
              {hasEditAccess(permissions, "reservation") && (
                <button
                  type="submit"
                  onClick={() => setSubmitAction("pay_now")}
                  className="btn btn-primary"
                  disabled={isLoading}
                >
                  {isLoading
                    ? "Processing..."
                    : isEditingMode
                    ? // ? `Update ${!isPaid ? "& Pay Now" : ""}`
                      `Update`
                    : !id && !isPaid
                    ? "Pay Now"
                    : // : `Update ${!isPaid ? "& Pay Now" : ""}`}
                      `Update`}
                </button>
              )}
              
              {/* Debug button - remove in production */}
              {process.env.NODE_ENV === 'development' && isLoading && (
                <button
                  type="button"
                  onClick={() => {
                    console.log('Manual reset of loading state');
                    setIsLoading(false);
                    dispatch({ type: RESET_BOOKING_SUCCESS });
                  }}
                  className="btn btn-warning"
                >
                  Reset Loading (Debug)
                </button>
              )}
              {!isDiscounts &&
                !(
                  isViewOnly ||
                  (isEditingMode && hasEditAccess(permissions, "reservation"))
                ) && (
                  <button
                    type="submit"
                    onClick={() => setSubmitAction("pay_later")}
                    className="btn btn-secondary"
                    disabled={isLoading}
                  >
                    {isLoading
                      ? "Processing..."
                      : isEditingMode
                      ? // ? "Update & Pay Later"
                        "Update"
                      : "Pay Later"}
                  </button>
                )}
            </>
          </div>
        </form>
      </div>

      {showPaymentModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-credit-card me-2"></i>
                  Complete Payment
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPaymentModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* Order Summary */}
                <div className="card mb-4">
                  <div className="card-header">
                    <h6 className="mb-0">Order Summary</h6>
                  </div>
                  <div className="card-body">
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td>Subtotal:</td>
                          <td className="text-end">
                            ₹{summaryData?.data?.subtotal.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Room Charge:</td>
                          <td className="text-end">
                            ₹{summaryData?.data?.totalRoomCharges.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Services:</td>
                          <td className="text-end">
                            ₹{summaryData?.data?.totalServiceCharges.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Tax ({formData.tax}%):</td>
                          <td className="text-end">
                            ₹{summaryData?.data?.totalTaxAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Discount ({formData.discount}%):</td>
                          <td className="text-end">
                            -₹{summaryData?.data?.totalDiscounts.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Extra Bed Charges:</td>
                          <td className="text-end">
                            ₹
                            {summaryData?.data?.totalExtraBedCharges.toFixed(2)}
                          </td>
                        </tr>
                        <tr className="table-active">
                          <td className="fw-bold">Total Amount:</td>
                          <td className="text-end fw-bold h5">
                            ₹{summaryData?.data?.grandTotal.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Payment Method */}
                <div className="mb-4">
                  <label className="form-label">Payment Method</label>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="cash"
                          value="cash"
                          checked={paymentMethod === "cash"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="cash">
                          <i className="bi bi-cash me-2"></i>Cash
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="debit_card"
                          value="debit_card"
                          checked={paymentMethod === "debit_card"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="debit_card"
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Debit Card
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="credit_card"
                          value="credit_card"
                          checked={paymentMethod === "credit_card"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="credit_card"
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Credit Card
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="upi"
                          value="upi"
                          checked={paymentMethod === "upi"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="upi">
                          <i className="bi bi-phone me-2"></i>UPI
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="bank_transfer"
                          value="bank_transfer"
                          checked={paymentMethod === "bank_transfer"}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="bank_transfer"
                        >
                          <i className="bi bi-globe me-2"></i>Bank Transfer
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowPaymentModal(false)}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={processPayment}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Processing Payment...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle me-2"></i>
                      Complete Payment (₹
                      {summaryData?.data?.grandTotal.toFixed(2)})
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddRoomBooking;
